module.exports = __webpack_public_path__ + "static/img/consumer_guide.2211e54.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/consumer_guide.gif
// module id = 430
// module chunks = 1